import React from "react";
import LegalPage from "./LegalPage";
import { SUPPORT_EMAIL } from "../components/SupportCard";

const H = ({ children }) => (
  <h2 className="text-white text-[17px] font-semibold tracking-tight mt-8 mb-2">{children}</h2>
);

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="February 2026">
      <p>
        This Privacy Policy explains what information FlowFinder collects, how
        we use it and the choices you have. We aim to keep this short and
        readable — if anything is unclear, please email{" "}
        <a className="text-[var(--bull)]" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>

      <H>What we collect</H>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Account data:</strong> email, name (optional), hashed password, plan, and OAuth identifiers if you sign in with Google.</li>
        <li><strong>Usage data:</strong> page views, scans run, tickers viewed, watchlists, saved scans, and session timestamps. Used to operate the product and produce admin analytics.</li>
        <li><strong>Technical data:</strong> a long-lived anonymous cookie (ff_anon), user-agent, approximate country/city derived from IP, and device type. We hash IPs before storing them in the geo-lookup cache.</li>
        <li><strong>Payment data:</strong> processed by Stripe. We never see or store your card details.</li>
      </ul>

      <H>How we use it</H>
      <ul className="list-disc pl-5 space-y-1">
        <li>Provide and improve the Service (running scans, computing indicators, sending account email).</li>
        <li>Authenticate sessions and protect against brute-force attempts.</li>
        <li>Produce aggregate analytics for the admin dashboard (visitors, DAU/WAU/MAU, retention).</li>
        <li>Communicate with you about your account, security or service updates.</li>
      </ul>

      <H>Cookies</H>
      <p>
        We use a single first-party cookie (<code>ff_anon</code>) to recognise
        returning browsers so we don't count refreshes as new visitors. Auth
        cookies (<code>access_token</code>, <code>refresh_token</code>,
        <code>session_token</code>) keep you signed in. We do not sell or
        share these with advertisers.
      </p>

      <H>Third-party services</H>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Stripe</strong> — subscription billing</li>
        <li><strong>Finnhub</strong> — live market data</li>
        <li><strong>Google OAuth</strong> (optional) — sign-in</li>
        <li><strong>ipapi.co</strong> — country-level geo lookup (IP is hashed in our cache)</li>
      </ul>

      <H>Your rights</H>
      <p>
        You can access, update or delete your account from the Profile page or
        by emailing us. We retain analytics events for up to 24 months, geo
        cache entries for up to 90 days, and account records as long as your
        account is active. Deleting your account removes your profile and
        unlinks events from your user ID.
      </p>

      <H>Security</H>
      <p>
        Passwords are hashed with bcrypt. Auth cookies are HttpOnly + Secure +
        SameSite=None. Database access is restricted; production secrets are
        kept in environment variables, not in source. We do our best — but no
        online service can guarantee perfect security.
      </p>

      <H>Children</H>
      <p>
        FlowFinder is not directed at children under 16. We do not knowingly
        collect personal information from anyone under 16.
      </p>

      <H>Changes</H>
      <p>
        We may update this Policy. Material changes will be communicated in-app
        or by email.
      </p>

      <H>Contact</H>
      <p>
        Questions or data requests? Email{" "}
        <a className="text-[var(--bull)]" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>
    </LegalPage>
  );
}
